import { render, staticRenderFns } from "./bottom-sheet-custom-rate.vue?vue&type=template&id=209f09b6&scoped=true&"
import script from "./bottom-sheet-custom-rate.vue?vue&type=script&lang=js&"
export * from "./bottom-sheet-custom-rate.vue?vue&type=script&lang=js&"
import style0 from "./bottom-sheet-custom-rate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./bottom-sheet-custom-rate.vue?vue&type=style&index=1&id=209f09b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209f09b6",
  null
  
)

export default component.exports